/* eslint-disable max-statements */
import React, { useState } from 'react'
import { func, object, string } from 'prop-types'
import Modal from '../Modal/Modal'
import { BtnGhost, BtnPrimary } from '../ui/buttons'
import CancelSuccess from './CancelSuccess'
import CancelOffers from './CancelOffers'
import CancelConfirm from './CancelConfirm'
import CancelStatusInfo from './CancelStatusInfo'
import ConversaInstagram from './ConversaInstagram'
import { REASONS } from './cancel-flow-config'
import {
  OptList,
  Opt,
  OptRadio,
  OptGrow
} from './cancel-flow-styles'

export const ORIGEM_FLUXO_PADRAO = 'fluxo_padrao'

export default function CancelFlow( {
  sub,
  situacao,
  onClose,
  onConfirm,
  onAddress,
  onUndo,
  onReactivate
} ) {
  const [ step, setStep ] = useState( 0 )
  const [ reason, setReason ] = useState( null )
  const [ submotivo, setSubmotivo ] = useState( null )
  const [ status, setStatus ] = useState( { 'submitting': false, 'erro': false } )
  const [ outcome, setOutcome ] = useState( null )
  const [ fimVigenciaNoCancelamento, setFimVigenciaNoCancelamento ] = useState( '' )

  const reasonObj = REASONS.find( ( item ) => item.codigo === reason ) || null
  const submotivos = reasonObj && reasonObj.submotivos.length ? reasonObj.submotivos : null

  const selecionaReason = ( codigo ) => {
    setReason( codigo )
    setSubmotivo( null )
  }

  const stepAntesDaOferta = submotivos ? 1 : 0

  const confirmaCancelamento = async( origem = ORIGEM_FLUXO_PADRAO ) => {
    setStatus( { 'submitting': true, 'erro': false } )
    try {
      const payload = { 'motivo': reason }
      if ( submotivo ) {
        payload.submotivo = submotivo
      }
      setFimVigenciaNoCancelamento( sub.fimVigencia )
      await onConfirm( payload, origem )
      setOutcome( 'cancelado' )
      return true
    } catch ( erro ) {
      setStatus( { 'submitting': false, 'erro': true } )
      return false
    }
  }

  const singleBtnFooter = ( label ) => (
    <BtnPrimary
      onClick={ onClose }
      type="button"
    >
      { label }
    </BtnPrimary>
  )

  if ( outcome === 'cancelado' ) {
    return (
      <Modal
        footer={ singleBtnFooter( 'Fechar' ) }
        onClose={ onClose }
        title="Cancelamento agendado"
      >
        <CancelSuccess
          comEstorno={ sub.comEstorno }
          fimVigencia={ fimVigenciaNoCancelamento || sub.fimVigencia }
        />
      </Modal>
    )
  }

  if ( situacao === 'cancelada' || situacao === 'em_processo' ) {
    return (
      <CancelStatusInfo
        onClose={ onClose }
        onReactivate={ onReactivate }
        onUndo={ onUndo }
        renewLong={ sub.renewLong }
        situacao={ situacao }
      />
    )
  }

  if ( step === 1 ) {
    return (
      <Modal
        eyebrow="Cancelar renovação"
        footer={ (
          <>
            <BtnGhost
              onClick={ () => setStep( 0 ) }
              type="button"
            >Voltar
            </BtnGhost>
            <BtnPrimary
              disabled={ !submotivo }
              onClick={ () => setStep( 2 ) }
              type="button"
            >Continuar
            </BtnPrimary>
          </>
        ) }
        onClose={ onClose }
        steps={{ 'cur': 0 }}
        title="Pode detalhar um pouco mais?"
      >
        <OptList>
          { submotivos.map( ( { codigo, texto } ) => (
            <Opt
              $selected={ submotivo === codigo }
              key={ codigo }
            >
              <input
                checked={ submotivo === codigo }
                hidden
                name="submotivo"
                onChange={ () => setSubmotivo( codigo ) }
                type="radio"
              />
              <OptRadio $selected={ submotivo === codigo } />
              <OptGrow>{ texto }</OptGrow>
            </Opt>
          ) ) }
        </OptList>
      </Modal>
    )
  }

  if ( step === 2 ) {
    return (
      <CancelOffers
        onAddress={ onAddress }
        onBack={ () => setStep( stepAntesDaOferta ) }
        onClose={ onClose }
        onContinue={ () => setStep( 3 ) }
        onConversar={ () => setStep( 4 ) }
        reason={ reason }
        sub={ sub }
        submotivo={ submotivo }
      />
    )
  }

  if ( step === 3 ) {
    return (
      <CancelConfirm
        erro={ status.erro }
        onBack={ () => setStep( 2 ) }
        onClose={ onClose }
        onConfirm={ () => confirmaCancelamento( ORIGEM_FLUXO_PADRAO ) }
        sub={ sub }
        submitting={ status.submitting }
      />
    )
  }

  if ( step === 4 ) {
    return (
      <ConversaInstagram
        onBack={ () => setStep( 2 ) }
        onClose={ onClose }
      />
    )
  }

  const footer = (
    <>
      <BtnGhost
        onClick={ onClose }
        type="button"
      >Voltar
      </BtnGhost>
      <BtnPrimary
        disabled={ !reason }
        onClick={ () => setStep( submotivos ? 1 : 2 ) }
        type="button"
      >Continuar
      </BtnPrimary>
    </>
  )
  return (
    <Modal
      eyebrow="Cancelar renovação"
      footer={ footer }
      onClose={ onClose }
      steps={{ 'cur': 0 }}
      sub="Sua resposta nos ajuda a melhorar a próxima edição. Leva menos de 10 segundos."
      title="O que motivou essa decisão?"
    >
      <OptList>
        { REASONS.map( ( { codigo, texto } ) => (
          <Opt
            $selected={ reason === codigo }
            key={ codigo }
          >
            <input
              checked={ reason === codigo }
              hidden
              name="reason"
              onChange={ () => selecionaReason( codigo ) }
              type="radio"
            />
            <OptRadio $selected={ reason === codigo } />
            <OptGrow>{ texto }</OptGrow>
          </Opt>
        ) ) }
      </OptList>
    </Modal>
  )
}

CancelFlow.propTypes = {
  'sub': object.isRequired,
  'situacao': string,
  'onClose': func.isRequired,
  'onConfirm': func.isRequired,
  'onAddress': func,
  'onUndo': func,
  'onReactivate': func
}

CancelFlow.defaultProps = {
  'situacao': 'ativa',
  'onAddress': null,
  'onUndo': null,
  'onReactivate': null
}
